module.exports = __webpack_public_path__ + "img/programmer.c50d7b48.gif";